import axios from 'axios'
import React, { useState, useEffect, useContext, useRef } from 'react'
import { useStore } from '../Store'
import useVisits from './useVisits'
import ObservationService from '../services/ObservationService'
const OnlineStatusContext = React.createContext(true)

const PING_RESOURCE = `${process.env.REACT_APP_BASEURL}/projects/${process.env.REACT_APP_PROJECTID}`
const TIMEOUT_TIME_MS = 5000
const onlinePollingInterval = process.env.REACT_APP_POLLING_INTERVAL

const checkOnlineStatus = async (setAppversion) => {
    if (!navigator.onLine) return false
    try {
        const response = await axios.get(PING_RESOURCE, { timeout: TIMEOUT_TIME_MS })
        setAppversion(response.data.appVersion)
        return true
    }
    catch (error) {
        console.error(error)
    }
    return false;
}

export const OnlineStatusProvider = ({ children }) => {
    const [onlineStatus, setOnlineStatus] = useState(false)
    const [startup, setStartup] = useState(true)
    const { appversion, setAppversion, unsaved, deleteUnsaved, updateUnsaved, reload, user } = useStore()
    const { updateVisit } = useVisits()

    const setAppversionRef = useRef(setAppversion)
    const deleteUnsavedRef = useRef(deleteUnsaved)
    const updateVisitRef = useRef(updateVisit)
    const updateUnsavedRef = useRef(updateUnsaved)

    useEffect(() => {

        const checkStatus = async () => {
            const online = await checkOnlineStatus(setAppversionRef.current)
            setOnlineStatus(online)
        }

        window.addEventListener("offline", () => {
            setOnlineStatus(false)
        })
        window.addEventListener("online", () => {
            setOnlineStatus(true)
        })

        checkStatus()
        const id = setInterval(() => {
            checkStatus()
        }, onlinePollingInterval)
        return () => {
            window.removeEventListener("offline", () => {
                setOnlineStatus(false)
            })
            window.removeEventListener("online", () => {
                setOnlineStatus(false)
            })
            clearInterval(id)
        }
    }, [])

    useEffect(() => {

        const saveData = async () => {
            const todo = unsaved.filter(item => !item.error)
            for (const item of todo) {
                try {
                    if ('observations' in item) {
                        await updateVisitRef.current(item, false, true)
                    } else {
                        await ObservationService.updateObservation(item)
                    }
                    deleteUnsavedRef.current(item)
                }
                catch (error) {
                    item.error = error
                    updateUnsavedRef.current(item)
                }
            }
        }

        if (onlineStatus) {
            saveData()
        }

    }, [unsaved, onlineStatus])

    useEffect( ()=> {
        const onStartup = async () => {
            if (user?.loggedin) {
                await reload()
                console.log('settings reloaded')
            }
            setStartup(false)
        }
        if (onlineStatus && appversion && process.env.REACT_APP_BUILD < appversion ) {
            alert('Er is een nieuwe versie van deze app beschikbaar.\n\n' +
            'Sluit deze versie af en start opnieuw om de nieuwe versie te gebruiken.');
          window.location.reload()
        }
        if (onlineStatus && startup) {
            onStartup()
        }
    }, [onlineStatus, appversion, user, startup])
    
    
    return (
        <OnlineStatusContext.Provider value={onlineStatus}>
            {children}
        </OnlineStatusContext.Provider>
    )
}
const useOnlineStatus = () => {
    const store = useContext(OnlineStatusContext)
    return store
}
export default useOnlineStatus
